module.exports = __webpack_public_path__ + "img/valentin-vilsans.4bb34e24.jpg";